export default "../images/stackloans-partners-with-OneMain_PORTAL_US.png?ce421ac0d13b9311d5338cee5d88db84";